import styles from '@/legacy/components/apps/modal.module.scss';
import type React from 'react';
import { useEffect, useState } from 'react';

import { clc, type BaseProps } from '@/legacy/components/base/utils';
import {
	prefixDiagonalAxisToAxis,
	rectToStyleOffset,
	rectToViewportStyleOffset,
	type Axis,
	type DiagonalAxis,
} from '@/utilities/dom';

type Props = {
	target: HTMLElement;
	offset: number;
	axis: DiagonalAxis;
	align: Axis;
	children: React.ReactNode;
};

/**
 * 화면 끝에 붙이는 기능을 가짐
 * align : 화면상 정렬 위치
 * @param param0
 * @returns
 */
const DiagonalViewportModal = ({ target, offset, axis, align, children }: Props & BaseProps['div']) => {
	const direction = prefixDiagonalAxisToAxis(axis);
	const temp = rectToStyleOffset(target, offset, direction);

	const [next, setNext] = useState(rectToViewportStyleOffset(temp, offset, align));

	useEffect(() => {
		const handleResize = () => {
			setNext(rectToViewportStyleOffset(temp, offset, align));
		};

		window.addEventListener('resize', handleResize);
		window.addEventListener('scroll', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
			window.removeEventListener('scroll', handleResize);
		};
	}, [target, offset, axis]);

	return (
		<div className={clc(styles.wrap, styles[axis])} style={{ ...next }}>
			{children}
		</div>
	);
};

export default DiagonalViewportModal;
